const BUILD_VERSION = new Date().toISOString()

module.exports = BUILD_VERSION

if (require.main === module) {
  console.log(`\nBUILD_VERSION=${BUILD_VERSION}`)
}
